function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { Modal as MuiModal, prepareForSlot } from '@mui/base';
import { forwardRef, useMemo } from 'react';
import { su, theme } from '@arc/frontend/ui-theme';
import { useWindowViewHeight } from '@arc/frontend/util-common';
export const styles = {
  modal: process.env.NODE_ENV === "production" ? {
    name: "wkkrci",
    styles: "position:fixed;inset:0;display:flex;align-items:center;justify-content:center"
  } : {
    name: "3256h1-modal",
    styles: "position:fixed;inset:0;display:flex;align-items:center;justify-content:center;label:modal;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  modalDialogOverride: /*#__PURE__*/css({
    padding: '1.25rem',
    backgroundColor: theme.colors.background.dialog,
    boxShadow: '0px 4px 16px 0px gray',
    borderRadius: '4px',
    overflowY: 'auto',
    boxSizing: 'border-box',
    animation: '0.3s cubic-bezier(0, 0, 0.2, 1) 0s 1 normal none running modal-slide-in'
  }, process.env.NODE_ENV === "production" ? "" : ";label:modalDialogOverride;"),
  modalHeader: /*#__PURE__*/css(su.text2xl, {
    color: theme.colors.text.primary,
    flex: '1 1 auto',
    paddingBottom: '1.25rem',
    margin: '0px',
    fontWeight: '700'
  }, process.env.NODE_ENV === "production" ? "" : ";label:modalHeader;"),
  modalBody: process.env.NODE_ENV === "production" ? {
    name: "lxyb4p",
    styles: "flex:1 1 auto;padding-bottom:0.75rem;margin:0px"
  } : {
    name: "14wfsib-modalBody",
    styles: "flex:1 1 auto;padding-bottom:0.75rem;margin:0px;label:modalBody;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  modalFooter: /*#__PURE__*/css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '1 1 auto',
    paddingTop: '1.25rem',
    margin: '0px',
    '& > :not(:first-of-type)': process.env.NODE_ENV === "production" ? {
      name: "10kuhi4",
      styles: "margin-left:1.25rem"
    } : {
      name: "1e4m3hw------not--first-of-type-",
      styles: "margin-left:1.25rem;label:-----not--first-of-type-;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:modalFooter;"),
  backdrop: /*#__PURE__*/css({
    zIndex: -1,
    position: 'fixed',
    inset: 0,
    background: '#00000033',
    WebkitTapHighlightColor: 'transparent'
  }, process.env.NODE_ENV === "production" ? "" : ";label:backdrop;")
};
export const Backdrop = prepareForSlot(forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function Backdrop(props, ref) {
  return <div {...props} ref={ref} css={styles.backdrop} />;
}));
export function Modal(props) {
  const {
    show,
    children,
    closeOnOverlayClick,
    closeOnEscapePress,
    disableFirstElementFocus,
    testid = 'modal',
    dialogStyleOverrides,
    rootStyleOverrides,
    onRequestClose
  } = props;
  const root = useMemo(() => prepareForSlot(forwardRef(function Root(rootProps, ref) {
    return <div {...rootProps} ref={ref} css={rootStyleOverrides} />;
  })), [rootStyleOverrides]);
  const windowHeight = useWindowViewHeight();
  return <MuiModal open={show} css={styles.modal} onClose={(_e, reason) => {
    if (reason === 'backdropClick' && closeOnOverlayClick) {
      onRequestClose?.();
    } else if (reason === 'escapeKeyDown' && closeOnEscapePress) {
      onRequestClose?.();
    }
  }} slots={{
    backdrop: Backdrop,
    root
  }} disableAutoFocus={disableFirstElementFocus}>
			<div data-testid={testid} css={[styles.modalDialogOverride, {
      maxHeight: windowHeight - 24
    }, dialogStyleOverrides, process.env.NODE_ENV === "production" ? "" : ";label:Modal;"]}>
				{children}
			</div>
		</MuiModal>;
}
function ModalHeader(props) {
  return <div css={[styles.modalHeader, props.containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:ModalHeader;"]} className={props.className}>
			{props.children}
		</div>;
}
function ModalFooter(props) {
  return <div css={[styles.modalFooter, props.containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:ModalFooter;"]} className={props.className}>
			{props.children}
		</div>;
}
function ModalBody(props) {
  return <div css={[styles.modalBody, props.containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:ModalBody;"]} className={props.className}>
			{props.children}
		</div>;
}

/** @deprecated Use ModalWithLayout */
Modal.Header = ModalHeader;
/** @deprecated Use ModalWithLayout */
Modal.Footer = ModalFooter;
/** @deprecated Use ModalWithLayout */
Modal.Body = ModalBody;